import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { HpButton } from '@hp/ui';
import type { Fmt } from './format';
import { QualityIssues } from './quality-issues';
import type { Report } from './use-report';

/** Attribution data quality (`pa-data-quality`): a score and the gaps that lower it, with the way to fix them. */
export function DataQuality({
  quality,
  fmt,
  from,
  to,
}: {
  quality: Report['quality'];
  fmt: Fmt;
  from: string;
  to: string;
}) {
  const { t } = useTranslation(['performance', 'common']);
  const navigate = useNavigate();
  return (
    <section className="pa-data-quality" id="pa-data-quality">
      <div className="pa-quality-score">
        {fmt.dec(quality.score * 100, 0)}
        <small>%</small>
      </div>
      <div>
        <h2>{t('dashboard.quality2.title')}</h2>
        <p className="pa-panel-subtitle">{t('dashboard.quality2.subtitle')}</p>
        <p>
          {t('dashboard.quality2.text', {
            noSource: fmt.int(quality.noSource),
            noCampaign: fmt.int(quality.noCampaign),
            cases: fmt.int(quality.cases),
            unmapped: fmt.compactCzk(quality.unmappedSpendCzk),
            unmappedShare: fmt.pct(quality.unmappedSpendShare, 0),
          })}
        </p>
        {(quality.unmappedStages > 0 || quality.unconvertedReservations > 0) && (
          <p>
            {t('dashboard.quality2.more', {
              stages: fmt.int(quality.unmappedStages),
              unconverted: fmt.int(quality.unconvertedReservations),
            })}
          </p>
        )}
        <HpButton
          variant="secondary"
          icon="link"
          className="bo-button--sm"
          onClick={() => void navigate('/marketing/performance/mappings')}
        >
          {t('dashboard.mappingsLink')}
        </HpButton>
        <QualityIssues from={from} to={to} fmt={fmt} />
      </div>
    </section>
  );
}
